export function getSectionParent(state, context) {
  let owner = state;
  if (!context || !context.fn || !state || state.isRoot) {
    return undefined;
  }
  const sids = context.fn.getSectionIds();
  while (owner) {
    const sid = owner.getValue('sid');
    if (sid && sids.indexOf(sid) >= 0) {
      return owner;
    }
    ({ owner } = owner);
  }
  return undefined;
}

export function defineSectionAction({
  proxy, section, scope,
}) {
  // 重新定义 action
  const sectionData = section && section.getValue() && section.getValue('settingEvents');
  if (sectionData && sectionData.length) {
    proxy.action = {};
    (sectionData || []).forEach((event) => {
      proxy.action[event.name] = (...args) => scope.execAction(event.name, ...args);
    });
  }
  // 定义 getPassThrough
  proxy.getPassThrough = () => section.getData('options');
}
